import { render, staticRenderFns } from "./ActivityModulePlaceholder.vue?vue&type=template&id=27d62571&scoped=true"
import script from "./ActivityModulePlaceholder.vue?vue&type=script&lang=js"
export * from "./ActivityModulePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ActivityModulePlaceholder.vue?vue&type=style&index=0&id=27d62571&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d62571",
  null
  
)

export default component.exports